import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DTFHomepageService } from '../components/dtfhomepage/dtfhomepage.service';
import { AuthorizationService } from '../components/authorization/authorization.service';
import { WindowRef } from '../utils/window';

import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { Banner } from '../shared/models/banner';
import { TranslateUtil } from '../utils/translate-util';
import { APP_CONSTANTS } from '../utils/app-constants';

import { AccoutDetailsResponse } from '../shared/models/accountDetailsResponse'
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { SelectionModel } from '@angular/cdk/collections';
import { ContractNumberRequest } from '../shared/models/contractNumberResponse';
import { DcsAccountNumber } from '../shared/models/dcsAccountNumber';
import { MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { SharedTranslateModule } from '../utils/sharedTranslateModule';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { AutoPayComponent } from '../components/autoPay/autoPay.component';
import { MatButtonModule } from '@angular/material/button';


enum CheckeBill {
  Enroll_ebill,
  Terminate_ebill,
  NONE
};



export enum ToggleEnum { //used for mat toggle
  Option1,
  Option2,
  Option3,
  Option4,
  Option5,
  Option6
}

@Component({
    selector: 'div.dtf-manageYourProfilepage',
    templateUrl: './manageYourProfile.component.html',
    providers: [],
    imports: [AutoPayComponent, MatInputModule,
        SharedTranslateModule, MatPaginator, MatSort, MatTableModule, MatCheckboxModule, MatFormFieldModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatSortModule
    ],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ]
})


export class ManageYourProfileComponent implements OnInit {
  title = 'Content Section of the Page';
  router: Router;
  path = '';
  loginRedirect = '';
  hideSingleSelectionIndicator=true;
  accountRedirect = '';
  password2 = '';
  password3 = '';
  reTypePassword = '';
  token: string;
  brandId: string;
  action = '';
  confirmPassword: string;
  error = '';
  loginAttempt = false;
  isLoginattempt = '';
  enrollFlagFromDB: string;
  countryFlag: string;
  langFlag: string;
  currentCountry: string;
  isCanadaPortal = false;
  passwordValidationFailed: boolean = false;
  contentChanged: boolean = false;
  popUpVisible: boolean = false;
  failurePopupVisible = false;
  successPopupVisible = false;
  showPasswordConfirmation = false;
  baseUrl = '';
  currentPassword = '';
  emailAddress = '';
  streetAddress ='';
  city ='';
  state ='';
  zipCode='';
  currentPasswordDBCheckFlag = false;
  usUrl: string;
  caUrl: string;
  azURL: string;
  agentview: string;
  agentId: string;
  bodyLoaded = false;
  dbLoaded = false;
  isFrench = false;
  managePassword = false;
  passwordReset = false;
  hasUpperCase = false;
  hasLowerCase = false;
  hasNumeric = false;
  hasMinimum = false;
  hasMaximum = false;
  userIDcheck = false;
  reentercheck = false;
  confirmReset = false;
  confirmEnroll = false;
  confirmTerminate = false;
  confirmEbillReset = false;
  reentermailcheck = false;
  confirmMailReset = false;
  confirmMailReset2 = false;
  contractSelected = false;
  password = '';
  hide = false;
  hide1 = false;
  hide2 = false;
  passwordRequest: any = {};
  EmailRequest: any = {};
  EbillRequest: any = {};
  openLoginModal = false;
  serviceErrorOccurred = false;
  serviceErrorDesc = '';
  userId = '';
  dbData: any;
  public alerts: Banner;
  toggleOpen: any;
  recAccCount = '';
  totalDue = '';
  emailUpdatePassword='';
  currentemailAddress= '';
  cemailAddress= '';
  isSaveButtonEnabled = false;
  language = '';
  emailOffers = true;
  isReset = false;
  userExist = false;
  marked = false;
  // theCheckbox = true;
  ciamId = sessionStorage.getItem('loginID');
  customerName = sessionStorage.getItem('customerName');
  thirdPartyNumber = sessionStorage.getItem('thirdPartyNumber');
  manageProfileForm: FormGroup;
  manageEmailForm: FormGroup;
  changeAddressForm :FormGroup;
  passwordForm: FormGroup;
  SelectEmail = true;
  SelectChangePassword = false;
  SelectAutopay = false;
  SelecteBill = false;
  SelectChangeAddress = false;
  SelectEnrollForm = false;
  SelectTerminateForm = false;
  disabledFlag =false;
  dataLoaded=true;
  CANCEL = '';
  // check_box_eBill = CheckeBill;
  // currentlyChecked: CheckeBill;
  // checkeBill = CheckeBill;
  // selectedEbill = CheckeBill.NONE;

  //used for mat-toggle
  toggleEnum = ToggleEnum;
  selectedState = ToggleEnum.Option6;
  value = '';
  isTerminatedAccounts = false;
  contract: ContractNumberRequest;
  dscAccount: DcsAccountNumber;
  dscAccountList: DcsAccountNumber[];

  accountDetailsRes: AccoutDetailsResponse[];
  tableLoaded = true;

  filterActive = false;
  filter = false;
  rowCount = 0;
  billingNumber: string;
  LessAccounts = false;
  EmailSentCopy = false;
  EmailSentCopyTerminate = false;

  stateLabelValues = [
    { label: 'Alabama', value: 'AL' },
    { label: 'Alaska', value: 'AK' },
    { label: 'American Samoa', value: 'AS' },
    { label: 'Arizona', value: 'AZ' },
    { label: 'Arkansas', value: 'AR' },
    { label: 'California', value: 'CA' },
    { label: 'Colorado', value: 'CO' },
    { label: 'Connecticut', value: 'CT' },
    { label: 'Delaware', value: 'DE' },
    { label: 'District of Columbia', value: 'DC' },
    { label: 'Florida', value: 'FL' },
    { label: 'Georgia', value: 'GA' },
    { label: 'Guam', value: 'GU' },
    { label: 'Hawaii', value: 'HI' },
    { label: 'Idaho', value: 'ID' },
    { label: 'Illinois', value: 'IL' },
    { label: 'Indiana', value: 'IN' },
    { label: 'Iowa', value: 'IA' },
    { label: 'Kansas', value: 'KS' },
    { label: 'Kentucky', value: 'KY' },
    { label: 'Louisiana', value: 'LA' },
    { label: 'Maine', value: 'ME' },
    { label: 'Maryland', value: 'MD' },
    { label: 'Massachusetts', value: 'MA' },
    { label: 'Michigan', value: 'MI' },
    { label: 'Minnesota', value: 'MN' },
    { label: 'Mississippi', value: 'MS' },
    { label: 'Missouri', value: 'MO' },
    { label: 'Montana', value: 'MT' },
    { label: 'Nebraska', value: 'NE' },
    { label: 'Nevada', value: 'NV' },
    { label: 'New Hampshire', value: 'NH' },
    { label: 'New Jersey', value: 'NJ' },
    { label: 'New Mexico', value: 'NM' },
    { label: 'New York', value: 'NY' },
    { label: 'North Carolina', value: 'NC' },
    { label: 'North Dakota', value: 'ND' },
    { label: 'Ohio', value: 'OH' },
    { label: 'Oklahoma', value: 'OK' },
    { label: 'Oregon', value: 'OR' },
    { label: 'Pennsylvania', value: 'PA' },
    { label: 'Puerto Rico', value: 'PR' },
    { label: 'Rhode Island', value: 'RI' },
    { label: 'South Carolina', value: 'SC' },
    { label: 'South Dakota', value: 'SD' },
    { label: 'Tennessee', value: 'TN' },
    { label: 'Texas', value: 'TX' },
    { label: 'Utah', value: 'UT' },
    { label: 'Vermont', value: 'VT' },
    { label: 'Virgin Islands', value: 'VI' },
    { label: 'Virginia', value: 'VA' },
    { label: 'Washington', value: 'WA' },
    { label: 'West Virginia', value: 'WV' },
    { label: 'Wisconsin', value: 'WI' },
    { label: 'Wyoming', value: 'WY' },
  ];

  stateCanadaLabelValues = [
    {
        "label": "Alberta",
        "value": "AB"
    },
    {
        "label": "British Columbia",
        "value": "BC"
    },
    {
        "label": "Manitoba",
        "value": "MB"
    },
    {
        "label": "New Brunswick",
        "value": "NB"
    },
    {
        "label": "Newfoundland and Labrador",
        "value": "NL"
    },
    {
        "label": "Northwest Territories",
        "value": "NT"
    },
    {
        "label": "Nova Scotia",
        "value": "NS"
    },
    {
        "label": "Nunavut",
        "value": "NU"
    },
    {
        "label": "Ontario",
        "value": "ON"
    },
    {
        "label": "Prince Edward Island",
        "value": "PE"
    },
    {
        "label": "Quebec",
        "value": "QC"
    },
    {
        "label": "Saskatchewan",
        "value": "SK"
    },
    {
        "label": "Yukon Territory",
        "value": "YT"
    }
];

      // Table columns
  // Table columns
  initColumns: any[] = [
    {
      name: 'select',
      display: '',
      displayMobile: '',
      displayFR: '',
      dispFormat: ''
    },
    {
      name: 'contractNum',
      display: 'Contract',
      displayFR: 'Numéro de contrat',
      dispFormat: 'contract'
    },
    {
      name: 'lastPayRcvd',
      display: 'Last Payment',
      displayFR: 'Dernier paiement reçu',
      dispFormat: 'currency'
    },
    {
      name: 'contractType',
      display: 'Contract Type',
      displayFR: 'Type de contrat',
      dispFormat: ''
    },
    {
      name: 'termDate',
      display: 'Maturity Date',
      displayFR: 'Date de maturité',
      dispFormat: 'date'
    },
    {
      name: 'totalDue',
      display: 'Current Due',
      displayFR: 'Solde actuel',
      dispFormat: 'currency'
    },
    {
      name: 'currentDt',
      display: 'Due Date',
      displayFR: 'Date d\'échéance',
      dispFormat: 'date'
    },
   {
      name: 'status',
      display: 'Status',
      displayFR: 'Statu',
      dispFormat: ''
    }
  ];
    displayedColumns: any[] = this.initColumns.map(col => col.name);
  
  
  dataSource: MatTableDataSource<AccoutDetailsResponse>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  selection = new SelectionModel<AccoutDetailsResponse>(true, []);


  constructor(router: Router, private dtfhomepageService: DTFHomepageService, private fb: FormBuilder, public auth: AuthorizationService,
    private _window: WindowRef, public translate: TranslateService, public translateUtil: TranslateUtil, public dialog: MatDialog, private cdRef: ChangeDetectorRef

  ) {
    this.router = router;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;

    this.accountDetailsRes =[];
    this.dataSource = new MatTableDataSource(this.accountDetailsRes);
  }

  ngAfterViewInit() {
  }


  onChangeButton($event) { //Used for mat-toggle conditions to filter DB
    this.selectedState = $event.value;
    this.disabledFlag = false;
    this.SelectEmail = false;
    this.SelectChangePassword = false;
    this.SelectAutopay = false;
    this.SelecteBill = false;
    this.SelectChangeAddress = false;
    
    if (this.selectedState === 0) {
      this.SelectEmail = true;
    }
    else if (this.selectedState === 1) {

      this.SelectChangePassword = true;

    }
    else if (this.selectedState === 2) {
      this.SelectAutopay = true;
    }
    else if (this.selectedState === 3) {
      this.SelecteBill = true;
      this.fetchEbillFlagForUser();
    }
    else if(this.selectedState ===4){
      this.SelectChangeAddress = true;
      this.getAccountDetailsListByUserId();
    }
  }
  onURLChangeButton(num: number) { //Used for mat-toggle conditions to filter DB
    this.selectedState = num;
    this.SelectEmail = false;
    this.SelectChangePassword = false;
    this.SelectAutopay = false;
    this.SelecteBill = false;
    this.SelectChangeAddress = false;


    if (this.selectedState === 0) {
      this.SelectEmail = true; 
    }
    else if (this.selectedState === 2) {
      this.SelectAutopay = true;
    }
    if (this.selectedState === 3) {
      this.SelecteBill = true;
      this.fetchEbillFlagForUser();
    }
    else if(this.selectedState ===4){
      this.SelectChangeAddress = true;
    }
  }

  ngOnInit() {
    this.recAccCount = sessionStorage.getItem('recAccCount');
    if(this.recAccCount && parseInt(this.recAccCount) < 450) {
      this.LessAccounts = true;
    }
    this.billingNumber = sessionStorage.getItem('billingNumber');
    sessionStorage.removeItem('addressdialog');
    this.agentview = sessionStorage.getItem('agentview');
    this.agentId = sessionStorage.getItem('agentID');
    const openProfile = (window as any).mbfs.openProfile;
    if (openProfile === "ebill") {
      this.onURLChangeButton(3);
    }
    else if (openProfile === "autopay") {
      this.onURLChangeButton(2);
    }
    else{
      this.onURLChangeButton(0);
    }
    const language = (window as any).mbfs.language;
    this.language= language;
    const country = (window as any).mbfs.country;
    this.countryFlag = country;
    this.langFlag = language;
    this.brandId = sessionStorage.getItem('brandId');
    this.token = sessionStorage.getItem('ciamToken');

    this.translateUtil.setCountryAndLangFromUIProp();
    this.translateUtil.getCurrentCountry().subscribe(val => {
      this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
      this.currentCountry = val;
      this.cdRef.detectChanges();
    });
    this.isFrench = ('fr-CA' === language) ? true : false; //checks if language is french or english for Canada

    const dashBoardRequest = {
      ciamId: this.ciamId,
      ciamAZCode: this.token
    };
    this.getDashBoardDetails(dashBoardRequest);
     let element: HTMLElement = document.getElementById('auto_triggeraddress') as HTMLElement;
    element.click();
    //this.getAlerts();
  }


  checkUrl(redirect: string) {
    this.isLoginattempt = sessionStorage.getItem('loginAttempt');
    sessionStorage.setItem('classicredirect', 'yes');
    this.formatAccountURl(redirect);
  }

  checkUrlParam(redirect: string, account: string) {
    this.isLoginattempt = sessionStorage.getItem('loginAttempt');
    sessionStorage.setItem('amortAccount', account);
    sessionStorage.setItem('classicredirect', 'yes');
    this.formatAccountURl(redirect);
  }
  anouncementMgsopen(e: any) {
    e.preventDefault();
    if (this.toggleOpen) {
      this.toggleOpen = false;
    } else {
      this.toggleOpen = true;
    }
  }

  // getAlerts() {
  //   this.dtfhomepageService.getAlerts().subscribe((res) => {
  //     for (var i = 0; i < res.length; i++) {
  //       if (this.currentCountry === 'CA') {
  //         if (res[i].bannerType === 'Alert' && res[i].bannerName.indexOf((this.langFlag)) !== -1 &&
  //           res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'CA') {
  //           this.alerts = res[i];
  //           this.dbData = true;
  //         }
  //       }
  //       else {
  //         if (res[i].bannerType === 'Alert' && res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'US') {
  //           this.alerts = res[i];
  //           this.dbData = true;
  //         }
  //       }
  //     }
  //   });
  // }

  formatAccountURl(redirect: string) {
    this.bodyLoaded = true;
    window.scrollTo(0, 0); // used to scroll to top of page
    if (this.countryFlag === 'CA') //CA Logic
    {
      this.azURL = this.accountRedirect + '?blink=' + redirect;
      if (this.langFlag === 'fr-CA') {
        if (redirect === 'insurance') {
          this.azURL = this.usUrl + '/ca/fr/home/insurance';
        }
        else if (redirect === 'amortization') {
          this.azURL = this.usUrl + '/ca/fr/home/amortization';
        }
        else if (redirect === 'documentcenter') {
          this.azURL = this.usUrl + '/ca/fr/home/documentcenter';
        }
      }
      else {
        if (redirect === 'insurance') {
          this.azURL = this.usUrl + '/ca/en/home/insurance';
        }
        else if (redirect === 'amortization') {
          this.azURL = this.usUrl + '/ca/en/home/amortization';
        }
        else if (redirect === 'documentcenter') {
          this.azURL = this.usUrl + '/ca/en/home/documentcenter';
        }
      }
    }
    else { //US Logic
      this.azURL = this.accountRedirect + '?blinkImage=null&blink=' + redirect;
      if (redirect === 'insurance') {
        this.azURL = this.usUrl + '/home/insurance';
      }
      else if (redirect === 'amortization') {
        this.azURL = this.usUrl + '/home/amortization';
      }
      else if (redirect === 'documentcenter') {
        this.azURL = this.usUrl + '/home/documentcenter';
      }
      else if (redirect === 'invoice') {
        this.azURL = this.usUrl + '/home/invoice';
      }
    }
    setTimeout(() => {
      this._window.nativeWindow.location.href = this.azURL;
    }, 1000);  //1s
  }

  formValidationClasses = {
    'mbfs-error': true,
  };
  buildForm() {
    this.manageProfileForm = this.fb.group({
      currentPassword: [''],
      password: [''],
      reTypePassword: ['']
    });
    this.manageEmailForm = this.fb.group({
      emailAddress: [''],
      reEnterEmailAddress: [''],
    });
    this.passwordForm = this.fb.group({
      password: ['']
    });
    this.changeAddressForm = this.fb.group({
      streetAddress: [''],
      city: [''],
      state: [''],
      zipCode: [''],
      emailAddress: ['']
      });
  }

  getDashBoardDetails(dashBoardRequest: any) {
    this.auth.getDashBoardDetails(dashBoardRequest).subscribe(res => {
      this.recAccCount = res.recAccCount;
      this.totalDue = res.totalDue;
      if(this.recAccCount && parseInt(this.recAccCount) == 0){
        this.isTerminatedAccounts = true;
      }
      if (this.totalDue.includes("-")) {
        this.totalDue = "0.00";
      }
      this.currentemailAddress = res.emailAddress;
      this.cdRef.detectChanges();
    });
  }
  //Password Validation

  onClickPassword(e: Event): void {
    this.buildForm();
    this.openLoginModal = true;
    //build login form
    this.manageProfileForm.get('currentPassword').setValidators(
      Validators.compose([Validators.required,
      Validators.minLength(12),
      Validators.maxLength(30),
      this.currentPasswordValidationCheck(),
      Validators.pattern('^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!_@#$&*?:=])(?=\\S+$).{12,30}$')])
    );
    this.manageProfileForm.get('password').setValidators(
      Validators.compose([Validators.required,
      Validators.minLength(12),
      Validators.maxLength(30),
      this.passwordValidationCheck(),
      Validators.pattern('^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!_@#$&*?:=])(?=\\S+$).{12,30}$')])
    );
    this.manageProfileForm.get('reTypePassword').setValidators(
      Validators.compose([Validators.required,
      Validators.minLength(12),
      Validators.maxLength(30),
      this.passwordEqualsCheck(),
      Validators.pattern('^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!_@#$&*?:=])(?=\\S+$).{12,30}$')]),
    );
    this.manageEmailForm.get('emailAddress').setValidators(
      Validators.compose([Validators.required,
      Validators.minLength(1),
      Validators.maxLength(60),
      Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+[\.]+[a-z]{2,4}$')])
    );
    this.manageEmailForm.get('reEnterEmailAddress').setValidators(
      Validators.compose([Validators.required,
      Validators.minLength(1),
      Validators.maxLength(60),
      this.EqualsCheck(),
      Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+[\.]+[a-z]{2,4}$')])
    );
  }

  passwordValidationCheck(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let passwordvalue = this.manageProfileForm.get('password').value;

      let notUserId = false;
      if (passwordvalue != this.userId) {
        notUserId = true;
      }
      this.userIDcheck = notUserId;
      this.hasUpperCase = /[A-Z]+/.test(passwordvalue);
      this.hasLowerCase = /[a-z]+/.test(passwordvalue);
      this.hasNumeric = /[0-9]+/.test(passwordvalue);
      this.hasMinimum = passwordvalue.length >= 12;
      this.hasMaximum = passwordvalue.length <= 30;
      const passwordValid = this.hasUpperCase && this.hasLowerCase && this.hasNumeric && this.userIDcheck;
      this.cdRef.markForCheck();

      return !passwordValid ? { passwordStrength: true } : null;
    }
  }

  currentPasswordValidationCheck(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let passwordvalue = this.manageProfileForm.get('currentPassword').value;

      let notUserId = false;
      if (passwordvalue != this.userId) {
        notUserId = true;
      }
      this.userIDcheck = notUserId;
      this.hasUpperCase = /[A-Z]+/.test(passwordvalue);
      this.hasLowerCase = /[a-z]+/.test(passwordvalue);
      this.hasNumeric = /[0-9]+/.test(passwordvalue);
      this.hasMinimum = passwordvalue.length >= 12;
      this.hasMaximum = passwordvalue.length <= 30;
      const passwordValid = this.hasUpperCase && this.hasLowerCase && this.hasNumeric && this.userIDcheck;
      this.cdRef.markForCheck();

      return !passwordValid ? { passwordStrength: true } : null;
    }
  }

  passwordEqualsCheck(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let resetvalue = this.manageProfileForm.get('reTypePassword').value;
      let passwordvalue = this.manageProfileForm.get('password').value;
      let notpasswordEqual = false;
      if (resetvalue === passwordvalue) {
        notpasswordEqual = true;
      }
      this.reentercheck = notpasswordEqual;
      const passwordValid = this.reentercheck;
      this.cdRef.markForCheck();
      return !passwordValid ? { passwordStrength: true } : null;
    }
  }


  updateAndSaveNewPassword(e: Event) {
    this.dataLoaded=false;
    this.cdRef.detectChanges();
    this.passwordRequest = {};
    if (!this.manageProfileForm.valid) {
      this.translate.get('Errors.userId_passwordMatch').subscribe((data: any) => {
        this.serviceErrorDesc = data;
        this.cdRef.detectChanges();
      });
      this.serviceErrorOccurred = true;
      this.cdRef.detectChanges();
      setTimeout(() => {
        this.serviceErrorOccurred = false;
        this.cdRef.detectChanges();
      }, 7000);  //2s
      this.dataLoaded=true;
      this.cdRef.detectChanges();
      return;
    }
    this.disabledFlag = true;
    this.password = this.manageProfileForm.get('password').value;
    this.reTypePassword = this.manageProfileForm.get('reTypePassword').value;
    this.currentPassword = this.manageProfileForm.get('currentPassword').value;
    this.passwordRequest = {
      ciamId: this.ciamId,
      ciamAZCode: this.token,
      currentPassword: this.currentPassword,
      password: this.password,
      reTypePassword: this.reTypePassword
    };

    this.auth.updateAndSaveNewPassword(this.passwordRequest).subscribe(res => {
      if (res.statusMessage === 'SUCCESS') {
        this.currentPasswordDBCheckFlag = true;
        this.confirmReset = true;
        this.emailUpdatePassword=res.updatedHashPassword;
        this.translate.get('LoginModal.SuccessPassword').subscribe((data: any) => {
          this.serviceErrorDesc = data;
          this.cdRef.detectChanges();
        });
      }
      else {
        this.disabledFlag = false;
        this.translate.get('LoginModal.InvalidCurrentPassword').subscribe((data: any) => {
          this.serviceErrorDesc = data;
          this.cdRef.detectChanges();
        });
        this.serviceErrorOccurred = true;
        this.currentPasswordDBCheckFlag = false;
        setTimeout(() => {
          this.serviceErrorOccurred = false;
          this.cdRef.detectChanges();
        }, 7000);  //2s
      }
      this.dataLoaded=true;
      this.cdRef.detectChanges();
    });
  }

  updateAndSaveCurrentPassword(confirmPassword: string) {
    return new Observable((observer) => {
      this.dataLoaded = false;
      this.cdRef.detectChanges();
      this.passwordRequest = {};
  
      if (!this.passwordForm.valid) {
        this.translate.get('Errors.userId_passwordMatch').subscribe((data: any) => {
          this.serviceErrorDesc = data;
          this.cdRef.detectChanges();
        });
        this.serviceErrorOccurred = true;
        this.cdRef.detectChanges();
        setTimeout(() => {
          this.serviceErrorOccurred = false;
          this.cdRef.detectChanges();
        }, 7000); // 7 seconds
  
        this.dataLoaded = true;
        this.cdRef.detectChanges();
        observer.next(false); // Emit a failure value
        observer.complete();
      } else {
        // Add confirmPassword to the passwordRequest object
        this.passwordRequest = {
          ciamId: this.ciamId,
          ciamAZCode: this.token,
          currentPassword: confirmPassword, // Use confirmPassword here
          password: confirmPassword, // New password
          reTypePassword: confirmPassword, // Retype new password
        };
  
        this.auth.updateAndSaveNewPassword(this.passwordRequest).subscribe(res => {
          if (res.statusMessage === 'SUCCESS') {
            this.emailUpdatePassword = confirmPassword;
            // Your success handling code here
            observer.next(true); // Emit a success value
          } else {
            // Your failure handling code here
            observer.next(false); // Emit a failure value
          }
          this.dataLoaded = true;
          this.cdRef.detectChanges();
          observer.complete();
        }, () => {
          this.dataLoaded = true;
          this.cdRef.detectChanges();
          observer.next(false);
          observer.complete();
        });
      }
    });
  }
  
  
  

  
  


  closeCIAMModal(e: Event) {
    this.openLoginModal = false;
    this.userExist = false;
    this.isReset = false;
    this.serviceErrorOccurred = false;
  }

  changeType(input_field_password : any, bool :any) {
    if (input_field_password.type === 'password') {
      input_field_password.type = 'text';
    } else {
      input_field_password.type = 'password';
    }
    bool = !bool;
  }

   EqualsCheck(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let email1value = this.manageEmailForm.get('reEnterEmailAddress').value;
      let email2value = this.manageEmailForm.get('emailAddress').value;
      let notemailEqual = false;
      if (email1value === email2value) {
        notemailEqual = true;
      }
      this.reentercheck = notemailEqual;
      const emailValid = this.reentercheck;
      this.cdRef.markForCheck();
      return !emailValid ? { mailStrength: true } : null;
    }
  }

  changeEmail(confirmPassword: string) {
    // Call the function to update and save the current password
    this.updateAndSaveCurrentPassword(confirmPassword).subscribe(
      (success) => {
        if (success) {
          // Handle success
          // Close the pop-up
          this.popUpVisible = false;
          // Set a flag to indicate that the content should change
          this.contentChanged = true;
          this.confirmPassword = '';
        } else {
          // Handle failure
          this.passwordValidationFailed = true;
        }
        this.cdRef.detectChanges();
      }
    );
  }
  

    
      
  
  
  closeSuccessPopup() {
    this.successPopupVisible = false;
  }
  
  closeFailurePopup() {
    this.failurePopupVisible = false;
  }
  
  showPassConfirmation (){
    this.showPasswordConfirmation = true;
  }
  cancelPasswordConfirmation() {
    this.showPasswordConfirmation = false; // Hide the password confirmation popup
  }
  updateEmailOffers(event: Event) {
    this.dataLoaded = false;
    this.cdRef.detectChanges();
    this.EmailRequest = {};
  
    // Store the initial value of this.currentemailAddress in a temporary variable
    const initialEmailAddress = this.currentemailAddress;
  
    if (!this.manageEmailForm.valid) {
      this.translate.get('Errors.userId_passwordMatch').subscribe((data: any) => {
        this.serviceErrorDesc = data;
        this.cdRef.detectChanges();
      });
      this.serviceErrorOccurred = true;
      this.cdRef.detectChanges();
      setTimeout(() => {
        this.serviceErrorOccurred = false;
        this.cdRef.detectChanges();
      }, 7000);  // 7 seconds
      this.dataLoaded = true;
      this.cdRef.detectChanges();
      return;
    }
  
   // this.disabledFlag = true;
  
    // Use the temporary variable in the EmailRequest object
    const EmailRequest = {
      ciamId: this.ciamId,
      ciamAZCode: this.token,
      emailAddress: initialEmailAddress,  // Use the initial value
      emailOffers: this.emailOffers,
      language: this.language,
      thirdParty:this.thirdPartyNumber,
      billingNumber:  this.billingNumber
    };
  
    this.auth.updateEmailPreferences(EmailRequest).subscribe(res => {
      if (res.statusMessage === 'SUCCESS') {
        this.confirmMailReset = true;
  
        // No need to update this.currentemailAddress here
  
        this.successPopupVisible = true; // Show success pop-up
        setTimeout(() => {
          this.successPopupVisible = false;
          this.cdRef.detectChanges();
        }, 5000);
      } else {
        if (this.language === 'en-CA') {
          this.serviceErrorDesc = res.status.message.shortMessage_EN;
        } else if (this.language === 'fr-CA') {
          this.serviceErrorDesc = res.status.message.shortMessage_FR;
        } else {
          this.serviceErrorDesc = res.status.message.shortMessage;
        }
        this.serviceErrorOccurred = true;
        setTimeout(() => {
          this.serviceErrorOccurred = false;
          this.cdRef.detectChanges();
        }, 7000);  // 7 seconds
        this.failurePopupVisible = true; // Show failure pop-up
      }
     // this.dataLoaded = true;
      this.cdRef.detectChanges();
    });
  }
  
  updateSaveButtonState() {
      this.isSaveButtonEnabled = true;
    
  }
  


  updateEmailPreferences(event: Event) {
    this.dataLoaded=false;
    this.cdRef.detectChanges();
    this.EmailRequest = {};
    if (!this.manageEmailForm.valid) {
      this.translate.get('Errors.userId_passwordMatch').subscribe((data: any) => {
        this.serviceErrorDesc = data;
        this.cdRef.detectChanges();
      });
      this.serviceErrorOccurred = true;
      setTimeout(() => {
        this.serviceErrorOccurred = false;
        this.cdRef.detectChanges();
      }, 7000);  //2s
      this.dataLoaded=true;
      this.cdRef.detectChanges();
      return;
    }
    //this.disabledFlag = true;
    this.emailAddress = this.manageEmailForm.get('emailAddress').value;
    const EmailRequest = {
      ciamId: this.ciamId,
      ciamAZCode: this.token,
      emailAddress: this.emailAddress,
      emailOffers: this.emailOffers,
      language: this.language,
      thirdParty:this.thirdPartyNumber,
      billingNumber:  this.billingNumber,
      password: this.emailUpdatePassword
    };


    this.auth.updateEmailPreferences(EmailRequest).subscribe(res => {
      if (res.statusMessage === 'SUCCESS') {
        this.confirmMailReset2 = true;
        this.currentemailAddress = this.emailAddress;
        this.tableLoaded = false;
        setTimeout(() => {
          this.contentChanged = false;
          this.showPasswordConfirmation = false;
          this.tableLoaded = true;
          this.confirmMailReset2 = false;
          this.manageEmailForm.reset();
          this.cdRef.detectChanges();
       

        }, 5000)
      }
      else {
        // If checks to load BE error messages based on language
        if (this.language === 'en-CA') {
          this.serviceErrorDesc = res.status.message.shortMessage_EN;
        } else if (this.language === 'fr-CA') {
          this.serviceErrorDesc = res.status.message.shortMessage_FR;
        } else {
          this.serviceErrorDesc = res.status.message.shortMessage;
        }
        this.serviceErrorOccurred = true;
        setTimeout(() => {
          this.serviceErrorOccurred = false;
          this.cdRef.detectChanges();
        }, 7000);  //2s
      }
      this.dataLoaded=true;
      this.cdRef.detectChanges();
    });
  }


  applyFilter(event: Event) {
    this.selectedState = undefined; //removes toggled mat-toggle
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    this.rowCount = this.dataSource.filteredData.length;
  }


  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.dataSource.data.forEach(row => this.selection.select(row));
  }

  checkToggleSelected(){
    this.dscAccountList = [];
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    if(numSelected < 1){
      sessionStorage.setItem('addressdialog', 'error');
      this.translate.get('Errors.SelectOneAccount').subscribe((data:any)=> {
        this.error= data;
        this.cdRef.detectChanges();
       });
      this.auth.SetErrorMessage(this.error);
      this.openDialog(5);
      this.contractSelected = false;
        }
    else{
      this.contractSelected = true;
    }
    for (var i = 0; i < this.selection.selected.length; i++) {
      this.dscAccount = new DcsAccountNumber();
      this.dscAccount.primaryCustomerAgreementNumber = this.selection.selected[i].contractNum.slice(0, -3);
      this.dscAccount.primaryCustomerScheduleNumber = "1";
      this.dscAccountList.push(this.dscAccount);
    }
   }

  getAccountDetailsListByUserId() {
    const accountDetailsRequest = {
      ciamId : this.ciamId ,
      ciamAZCode :this.token
    };
    this.auth.getAccountDetailsListByUserId(accountDetailsRequest).subscribe(res => {
      this.accountDetailsRes = [];
      this.accountDetailsRes = res.accountdetailsList;
      for (var i = this.accountDetailsRes.length - 1; i >= 0; i--) {
        if(this.accountDetailsRes[i].status !== 'LIVE'){
          this.accountDetailsRes.splice(i,1);
        }
        else if(this.accountDetailsRes[i].terminationQuoteBlocked){
          this.accountDetailsRes.splice(i,1);
        }
      }
      this.dataSource = new MatTableDataSource(this.accountDetailsRes);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.filterPredicate = function(data, filter: string): boolean {
        return data.contractNum.toLowerCase().includes(filter) || data.status.toLowerCase().includes(filter) || data.contractType.toLowerCase().includes(filter);
      };
      setTimeout(()=>{
        this.dbLoaded = true;
        this.filter = true;
        this.rowCount = this.dataSource.filteredData.length;
        this.cdRef.detectChanges();
   });
      this.cdRef.detectChanges();
  });
  }

  changeOfAddress(event: Event) {
    this.checkToggleSelected();
    if(this.contractSelected){
    if(!this.streetAddress){
      sessionStorage.setItem('addressdialog', 'error');
      this.translate.get('Errors.AddressIsMissing').subscribe((data:any)=> {
        this.error= data;
        this.cdRef.detectChanges();
       });
      this.auth.SetErrorMessage(this.error);
      this.openDialog(5);
    }
    else if(!this.city){
      sessionStorage.setItem('addressdialog', 'error');
      this.translate.get('Errors.CityIsMissing').subscribe((data:any)=> {
        this.error= data;
        this.cdRef.detectChanges();
       });
      this.auth.SetErrorMessage(this.error);
      this.openDialog(5);
    }
    else if(!this.state){
      sessionStorage.setItem('addressdialog', 'error');
      this.translate.get('Errors.StateIsMissing').subscribe((data:any)=> {
        this.error= data;
        this.cdRef.detectChanges();
       });
      this.auth.SetErrorMessage(this.error);
      this.openDialog(5);
    }
    else if(!this.zipCode){
      sessionStorage.setItem('addressdialog', 'error');
      this.translate.get('Errors.ZipCodeIsMissing').subscribe((data:any)=> {
        this.error= data;
        this.cdRef.detectChanges();
       });
      this.auth.SetErrorMessage(this.error);
      this.openDialog(5);
    }
    // else if(!this.emailAddress){
    //   sessionStorage.setItem('addressdialog', 'error');
    //   this.auth.SetErrorMessage('Email is Missing');
    //   this.openDialog(5);
    // }
    else{
    this.emailAddress = sessionStorage.getItem('emailAddress');
    this.disabledFlag = true;
    let changeAddressFormRequest;

    if (this.language === 'en-CA' || this.language === 'fr-CA') {
       changeAddressFormRequest = {
        ciamId: this.ciamId,
        ciamAZCode: this.token,
        emailAddress: this.emailAddress,
        city: this.city,
        zip: this.zipCode,
        newStreetAddress: this.streetAddress,
        state: this.state,
        dcsAccountNumber: this.dscAccountList,
        country: this.currentCountry,
        language : this.language
      };
    }else{
       changeAddressFormRequest = {
        ciamId: this.thirdPartyNumber,
        firstName:this.customerName,
        ciamAZCode: this.token,
        emailAddress: this.emailAddress,
        city: this.city,
        zip: this.zipCode,
        newStreetAddress: this.streetAddress,
        state: this.state,
        dcsAccountNumber: this.dscAccountList,
        country: this.currentCountry,
        language : this.language
      };
    }
    
   
    this.auth.changeOfAddress(changeAddressFormRequest).subscribe(res => {
      if (res.statusMessage === 'SUCCESS') {
        this.openDialog(1);
      }
      else {
        sessionStorage.setItem('addressdialog', 'error');
        this.translate.get('Errors.ErrorHasOccurred').subscribe((data:any)=> {
          this.error= data;
          this.cdRef.detectChanges();
         });
        this.auth.SetErrorMessage(this.error);
        this.openDialog(5);
        // If checks to load BE error messages based on language
        if (this.language === 'en-CA') {
          this.serviceErrorDesc = res.status.message.shortMessage_EN;
        } else if (this.language === 'fr-CA') {
          this.serviceErrorDesc = res.status.message.shortMessage_FR;
        } else {
          this.serviceErrorDesc = res.status.message.shortMessage;
        }
        this.serviceErrorOccurred = true;
        setTimeout(() => {
          this.serviceErrorOccurred = false;
          this.cdRef.detectChanges();
        }, 7000);  //2s
        this.disabledFlag = false;
      }
      this.dataLoaded=true;
      this.cdRef.detectChanges();
    }, () => {
      this.disabledFlag = false;
      this.dataLoaded = true;
      this.cdRef.detectChanges();
    });
  }
    }
    else{

    }
  }

  fetchEbillFlagForUser() {
    this.dataLoaded=false;
    this.cdRef.detectChanges();
     this.SelectEnrollForm = false;
     this.SelectTerminateForm = false;
    this.EbillRequest = {};
    this.EbillRequest = {
      ciamId: this.ciamId,
      ciamAZCode: this.token,
      isRegistration:"false"
    };
    this.auth.fetchEbillFlagForUser(this.EbillRequest).subscribe(res => {

      if (res.statusMessage === 'SUCCESS') {
        if (res.enrollFlagFromDB === 'ENROLL') {
          this.SelectTerminateForm = true;
          }
        else {
           this.SelectEnrollForm = true;
        }
      }
      else {
      this.SelectEnrollForm = true;
      this.serviceErrorOccurred = true;
      }
      this.dataLoaded=true;
      this.cdRef.detectChanges();
    }, () => {
      this.dataLoaded = true;
      this.cdRef.detectChanges();
});
  }
  saveEnrollOrCancelOptionToALFA(enrollType: string) {
    this.dataLoaded=false;
    this.cdRef.detectChanges();
    this.EbillRequest = {};
    this.EbillRequest = {
      ciamId: this.ciamId,
      ciamAZCode: this.token,
      isRegistration: false,
      action: enrollType,
      language:this.language,
      brandId:this.brandId
    };
    this.disabledFlag = true;
    //Accounts more than 450 -- copy and loader
    if(!this.LessAccounts){
    if (enrollType == 'ENROLL') {
      this.confirmEnroll = false;
      this.confirmTerminate = false;
      this.EmailSentCopy = true;
    }
    else {
      this.confirmTerminate = false;
      this.confirmEnroll = false;
      this.EmailSentCopyTerminate = true;
    }
   }
    this.auth.saveEnrollOrCancelOptionToALFA(this.EbillRequest).subscribe(res => {
      if (res.statusMessage === 'SUCCESS') {
        if (this.LessAccounts) {
          if (enrollType == 'ENROLL') {
            this.confirmEnroll = true;
            this.confirmTerminate = false;
          }
          else {
            this.confirmTerminate = true;
            this.confirmEnroll = false;
          }
        }
      }
      else {
        // If checks to load BE error messages based on language
        this.serviceErrorOccurred = true;
        this.cdRef.detectChanges();
        setTimeout(() => {
          this.serviceErrorOccurred = false;
          this.cdRef.detectChanges();
        }, 2000);  //2s
      }
      this.dataLoaded=true;
      this.cdRef.detectChanges();
    }, () => {
      this.disabledFlag = false;
      this.dataLoaded = true;
      this.cdRef.detectChanges();
    });
  }

  openDialog(num:any): void {
    if(num===1){
      sessionStorage.setItem('addressdialog', 'one');
    }
    if(num===5){
      sessionStorage.setItem('addressdialog', 'error');
    }
  let dialogRef = this.dialog.open(manageYourProfileDialogComponent, {
    maxWidth: '200vw',
    width: '500px',
  });

  // dialogRef.afterClosed().subscribe(result => {
  //   if(num===1){
  //     sessionStorage.setItem('addressdialog', 'two');
  //   }
  //   if(num===5){
  //     sessionStorage.setItem('addressdialog', 'error');
  //   }
  // });
}
}



@Component({
    selector: 'dialog-manageYourProfilePopup',
    imports: [MatButtonModule,MatDialogContent, MatDialogActions, MatDialogClose],
    templateUrl: 'manageYourProfileDialog.component.html'
})
export class manageYourProfileDialogComponent {
  usUrl: string;
  caUrl: string;
  addressdialog: string;
  language : string;
  errorMessage: string;
  contractNumberList: ContractNumberRequest[];

  constructor(router: Router, private dtfhomepageService: DTFHomepageService, private fb: FormBuilder, public auth: AuthorizationService,
    private _window: WindowRef, public translate: TranslateService, public translateUtil: TranslateUtil, public dialog: MatDialog, private cdRef: ChangeDetectorRef

  ) {
    this.contractNumberList = [];
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
    this.addressdialog = sessionStorage.getItem('addressdialog');
    this.language = sessionStorage.getItem('language');

    this.auth.cast2.subscribe((results:any)=> {
      this.contractNumberList = results;
      this.cdRef.detectChanges();
     });
     this.auth.cast3.subscribe((errorMessage:any)=> {
      this.errorMessage = errorMessage;
      this.cdRef.detectChanges();
     });
  }
  

dashboardRedirect(e: Event) {
    let redirect = '';
    this.translate.get('LoginModal.AutoPayRedirect').subscribe((data:any)=> {
      redirect= this.usUrl +  data;
     });
     window.location.href = redirect;
  }
}